<!-- 首页公告管理 -->
<template>
  <div class="notice-page" v-loading="loading">
    <div class="page-header">
      <span class="page-title">小程序首页公告</span>
    </div>
    <el-form :inline="true">
      <el-form-item
        label="所属门店:"
        style="margin:10px"
        size="small"
        v-if="filterStoreList && filterStoreList.length > 0"
      >
        <el-select
          v-model="store_id"
          @change="handleStoreChange"
          placeholder="请选择门店"
          style="width: 300px;"
        >
          <el-option
            v-for="(item, index) in filterStoreList"
            :key="index"
            :label="item.store_name"
            :value="item.store_id + ''"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <el-card class="notice-card" shadow="never">
      <el-form :model="form" :rules="rules" ref="noticeForm" label-width="90px">
        <el-form-item label="公告内容" prop="message">
          <el-input type="textarea" v-model="form.message" :rows="3" placeholder="请输入公告内容"></el-input>
        </el-form-item>
        <el-form-item label="字体颜色">
          <div class="color-picker-row">
            <el-color-picker show-alpha color-format="hex" v-model="form.color"></el-color-picker>
            <span class="color-value">{{ form.color || '默认' }}</span>
            <el-button type="text" size="mini" @click="form.color = ''" v-if="form.color">重置</el-button>
          </div>
        </el-form-item>
        <el-form-item label="背景颜色">
          <div class="color-picker-row">
            <el-color-picker show-alpha color-format="hex" v-model="form.bg_color"></el-color-picker>
            <span class="color-value">{{ form.bg_color || '默认' }}</span>
            <el-button type="text" size="mini" @click="form.bg_color = ''" v-if="form.bg_color">重置</el-button>
          </div>
        </el-form-item>

        <!-- 效果预览 -->
        <el-form-item label="效果预览">
          <div
            class="preview-bar"
            :style="{
              color: form.color || '#333',
              backgroundColor: form.bg_color || '#fffbe6',
            }"
          >{{ form.message || '公告内容预览' }}</div>
        </el-form-item>

        <el-form-item label="创建时间" v-if="form.create_time">
          <span class="meta-text">{{ form.create_time }}</span>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            :loading="submitLoading"
            v-waves
            @click="handleSubmit"
          >{{ form.id ? '保存修改' : '新增公告' }}</el-button>
          <el-button type="danger" plain v-if="form.id" @click="handleDelete">删除公告</el-button>
          <el-button v-if="form.id" @click="resetToSaved">撤销更改</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import {
  selectApi,
  addApi,
  updateApi,
  deleteApi
} from "@/services/notice/index";
import { mapState } from "vuex";
export default {
  name: "Notice",
  data() {
    return {
      loading: false,
      submitLoading: false,
      savedData: null,
      store_id: '',
      form: {
        id: null,
        message: "",
        color: "",
        bg_color: "",
        create_time: ""
      },
      rules: {
        message: [
          { required: true, message: "请输入公告内容", trigger: "blur" }
        ]
      }
    };
  },
  created() {
    // 初始化门店筛选
    if (this.filterStoreList && this.filterStoreList.length > 0) {
      // 默认选中第一项
      this.store_id = this.filterStoreList[0].store_id + "";
    }
    this.getNotice();
  },
  computed: {
    ...mapState(["userInfo", "filterStoreList"])
  },
  methods: {
    async getNotice() {
      this.loading = true;
      try {
        const { code, data } = await selectApi({
          store_id: this.store_id
        });
        if (code === 200 && data && data.length > 0) {
          this.savedData = data[0];
          this.fillForm(data[0]);
        } else {
          // 没有查询到数据时清空表单，支持新增
          this.savedData = null;
          this.form = {
            id: null,
            message: "",
            color: "",
            bg_color: "",
            create_time: ""
          };
        }
      } finally {
        this.loading = false;
      }
    },
    fillForm(row) {
      this.form = {
        id: row.id || null,
        message: row.message || "",
        color: row.color || "",
        bg_color: row.bg_color || "",
        create_time: row.create_time || ""
      };
    },
    handleDelete() {
      this.$confirm("确定删除该公告吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const { code } = await deleteApi({ id: this.form.id });
          if (code === 200) {
            this.$message.success("删除成功");
            this.savedData = null;
            this.form = {
              id: null,
              message: "",
              color: "",
              bg_color: "",
              create_time: ""
            };
          }
        })
        .catch(() => {});
    },
    handleSubmit() {
      this.$refs.noticeForm.validate(async valid => {
        if (!valid) return;
        this.submitLoading = true;
        try {
          const isEdit = !!this.form.id;
          const api = isEdit ? updateApi : addApi;
          const payload = {
            message: this.form.message,
            color: this.form.color,
            bg_color: this.form.bg_color,
            store_id: this.store_id
          };
          if (isEdit) payload.id = this.form.id;
          const { code, data } = await api(payload);
          if (code === 200) {
            this.$message.success(isEdit ? "保存成功" : "新增成功");
            await this.getNotice();
          }
        } finally {
          this.submitLoading = false;
        }
      });
    },
    resetToSaved() {
      if (this.savedData) {
        this.fillForm(this.savedData);
        this.$refs.noticeForm && this.$refs.noticeForm.clearValidate();
      }
    },
    handleStoreChange() {
      // 门店切换时重新获取公告
      this.getNotice();
    }
  }
};
</script>

<style scoped lang="less">
.notice-page {
  padding: 20px;
  background: #fff;
}
.page-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.page-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}
.notice-card {
  max-width: 640px;
}
.color-picker-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.color-value {
  font-size: 13px;
  color: #606266;
  font-family: monospace;
}
.preview-bar {
  padding: 8px 14px;
  border-radius: 4px;
  font-size: 13px;
  min-height: 36px;
  line-height: 1.6;
  border: 1px dashed #dcdfe6;
  word-break: break-all;
}
.meta-text {
  font-size: 13px;
  color: #909399;
}
</style>
